/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content/Delete/Content/DeleteAction/Content",
  onSubmit,
  isSubmitting
  
}) {
let deleteAppointmentSubmitData = fromData.useDataSubmit({ viewPath,
context: 'delete_appointment',
})
let deleteAppointmentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'delete_appointment',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="delete_appointment"
 onClick={deleteAppointmentSubmitData}
 disabled={deleteAppointmentIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Delete"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}